import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=16d921c8&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=16d921c8&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d921c8')) {
      api.createRecord('16d921c8', component.options)
    } else {
      api.reload('16d921c8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=16d921c8&", function () {
      api.rerender('16d921c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/recommend/components/detail.vue"
export default component.exports